<div class="d-flex flex-column">

  <ng-container *ngIf="insuranceContract.previousDamages">
    <ng-container *ngFor="let previousDamage of insuranceContract.previousDamages">

      <ng-container
        *ngIf="previousDamage.amountPaid != null && previousDamage.amountPaid > 0">
        <div>
          <hr>
          <div class="d-flex proposal-details-row">
            <div class="col proposal-details-row-header">{{previousDamage.year}}</div>
          </div>
          <div class="d-flex proposal-details-row">
            <div class="info-col">{{'createProposal.amountPaid' | translate}}:</div>
            <div>{{previousDamage.amountPaid | currency:
              previousDamage.currency: 'symbol': Formats.CURRENCY: localeService.getLocale()}}</div>
          </div>
          <div class="d-flex proposal-details-row">
            <div class="info-col">{{'createProposal.damageType' | translate}}:</div>
            <div>{{previousDamage.type}}</div>
          </div>
        </div>
      </ng-container>

    </ng-container>
  </ng-container>
</div>
